import React from "react";
import { getStatusMeta } from "../leadConstants";

const StatusBadge = ({ status }) => {
  const meta = getStatusMeta(status);

  return (
    <span
      className="lm-status-badge"
      style={{ "--lm-status": meta.color, "--lm-status-bg": meta.bg }}
    >
      <span className="lm-status-dot" />
      {meta.label}
    </span>
  );
};

export default StatusBadge;
